
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"fill":"#234593","d":"M20.1 25.1h9.3v11.8h-9.3zM9.7 37.9h30.4V46H9.7z"}}),_c('path',{attrs:{"fill":"#234593","d":"M18.9 33.3C13.1 30.9 9 25.4 9 19c0-8.6 7.1-15.6 15.8-15.6s15.8 7 15.8 15.6c0 6.5-4.1 12.2-10 14.5v-7.1c2.2-1.8 3.7-4.4 3.7-7.4 0-5.2-4.3-9.4-9.6-9.4s-9.6 4.2-9.6 9.4c0 2.9 1.4 5.5 3.5 7.2l.3 7.1z"}})])
          )
        }
      }
    